import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table-6';
import Theme from "./Theme.js";
/** 
 * React class that renders a table 
 * @see {@link https://github.com/tannerlinsley/react-table}
 * @property {string} className - css class to be applied to this component 
 * @property {string} variant - Theme variant name to be added to the component 
 * @property {any} tableRef - react reference 
 * @property {array} data - the data to be displayed on the table 
 * @property {array} columns - array of objects the defines the column header and which portion of the data to display 
 */
import { jsx as _jsx } from "react/jsx-runtime";
class Table extends React.Component {
  static contextType = Theme.Context;
  static propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string,
    tableRef: PropTypes.any,
    data: PropTypes.array,
    columns: PropTypes.array
  };
  static defaultProps = {
    className: null,
    variant: null,
    tableRef: null,
    data: null,
    columns: null
  };
  render() {
    const theme = this.context;
    const {
      className,
      variant,
      tableRef,
      layoutOptions,
      ...rest
    } = theme.props('Table', this.props);
    return /*#__PURE__*/_jsx(ReactTable, {
      ref: tableRef,
      className: theme.classes('Table', 'table', variant, className),
      ...rest
    });
  }
}
export default Table;